// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventWeekListBody = {
  leagueId: string;
  seasonWeek: number;
  timeZone: string;
  conferenceKey?: string | null;
};

export type typeEventWeekListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    leagueId: string;
    seasonId?: string | null;
    seasonWeek: number;
    timeZone: string;
    events: {
      eventId: string;
      leagueId: string;
      seasonId: string;
      kickoffAt: string;
      status:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
      statusLabel: string;
      statusDetail?: string | null;
      isLive: boolean;
      isKickoffPassed: boolean;
      winnerTeamId?: string | null;
      isTie: boolean;
      home: {
        teamId: string;
        name: string;
        abbreviation: string;
        logoMediaId?: string | null;
        primaryColorHex?: string | null;
        score?: number | null;
        recordLabel?: string | null;
        logoUrl?: string | null;
        shortName?: string | null;
        pollRankLabel?: string | null;
      };
      away: {
        teamId: string;
        name: string;
        abbreviation: string;
        logoMediaId?: string | null;
        primaryColorHex?: string | null;
        score?: number | null;
        recordLabel?: string | null;
        logoUrl?: string | null;
        shortName?: string | null;
        pollRankLabel?: string | null;
      };
      liveState?: {
        possessionTeamId?: string | null;
        baseball?: {
          balls: number;
          strikes: number;
          outs: number;
          isFirstOccupied: boolean;
          isSecondOccupied: boolean;
          isThirdOccupied: boolean;
          countLabel: string;
          outsLabel: string;
          pitcher?: { name: string; lineLabel: string | null } | null;
          batter?: { name: string; lineLabel: string | null } | null;
        } | null;
        football?: {
          ballSpotLabel: string;
          ballSpotPercentFromAway: number;
          firstDownPercentFromAway?: number | null;
          driveStartPercentFromAway?: number | null;
          driveSummaryLabel?: string | null;
        } | null;
        summaryLabel: string;
        downAndDistanceLabel?: string | null;
        hockey?: { powerPlayTeamId: string; powerPlayLabel: string } | null;
      } | null;
      hasAlertsOn?: boolean;
      pregameLine?: { label: string; spokenLabel: string } | null;
    }[];
    refreshAfterSeconds: number;
    conferenceKey?: string | null;
  };
};

export type typeEventWeekListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventWeekListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventWeekListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventWeekListBody = {
  type: "object",
  properties: {
    leagueId: { type: "string", maxLength: 3000, minLength: 1 },
    seasonWeek: { type: "integer" },
    timeZone: { type: "string", maxLength: 3000, minLength: 1 },
    conferenceKey: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["leagueId", "seasonWeek", "timeZone"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventWeekList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventWeekListBody);
  }

  return async function postEventWeekList(
    payload: typeEventWeekListBody,
  ): Promise<typeEventWeekListOutput200 | typeEventWeekListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventWeekList" failed before calling the network. #8826cebf8111`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#8826cebf8111" },
        },
        data: null,
      } as typeEventWeekListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/week-list`,
      httpMethod: "POST",
      options,
    })) as typeEventWeekListOutput200 | typeEventWeekListOutput400;
  };
}
